import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { useAuth, authHeaders } from "../../lib/auth";

export default function CoachEarnings() {
  const { token } = useAuth();
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/coach/orders", { headers: authHeaders(token) }).then((r) => {
      const raw = r.data;
      const orders = Array.isArray(raw) ? raw : (Array.isArray(raw?.orders) ? raw.orders : []);
      const earningsNum = Number(raw?.earnings);
      const earnings = Number.isFinite(earningsNum) ? earningsNum : 0;
      setData({ orders, earnings });
    }).catch(() => setData({ orders: [], earnings: 0 }));
  }, [token]);
  if (!data) return <div className="p-12 text-white/40">Loading…</div>;
  const completed = (data.orders || []).filter((o) => o.workspace_status === "completed");
  return (
    <div className="px-6 md:px-12 py-12 max-w-4xl">
      <div className="text-[11px] tracking-[0.32em] uppercase text-[#2A5BFF]">Coach</div>
      <h1 className="font-anton uppercase text-5xl md:text-6xl leading-[0.9]" data-testid="coach-earnings-heading">Earnings</h1>
      <div className="mt-8 p-6 border border-[#2A5BFF] bg-[#2A5BFF]/[0.06]">
        <div className="text-[10px] tracking-[0.28em] uppercase text-white/50">Total earned</div>
        <div className="font-anton text-6xl text-[#2A5BFF] mt-2" data-testid="coach-earnings-total">£{Number(data.earnings ?? 0).toFixed(2)}</div>
        <div className="text-white/50 text-sm mt-2">{completed.length} completed review{completed.length !== 1 ? "s" : ""} · 70% payout rate</div>
      </div>
      <div className="mt-10 border border-white/10 divide-y divide-white/10">
        {completed.length === 0 && <div className="p-5 text-white/40 text-sm">No completed reviews yet.</div>}
        {completed.map((o) => (
          <div key={o.id} className="p-4 flex items-center justify-between text-sm">
            <div><span className="text-white/90">{o.service_title}</span> <span className="text-white/40 ml-2">{o.id.slice(0,8)}</span></div>
            <div className="text-[#2A5BFF]">£{o.coach_payout?.toFixed(2)}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
